import sortBy from 'lodash/sortBy';

import {baseComparator, boolComparator} from 'common/util/array';
import {lexicalCompose} from 'common/util/function';
import {getIconForEvent} from '../../report/util';
import {SPECIAL_EVENTS} from '../../report/constants';
import {PropertyItem} from './properties-menu/types';
import {CohortSegment} from './segment-menu/types';

/**
 * Prepare one custom event entry for display in mp-items-menu
 * @param {object} customEvent - custom event from query response
 * @return {object} - object compatible with mp-items-menu component
 */
export function getCustomEventMenuItem(customEvent) {
  return {
    ...customEvent,
    custom: true,
    isCollectEverything: customEvent.is_collect_everything_event,
    icon: getIconForEvent({...customEvent, custom: true}),
    label: customEvent.name,
    value: `$custom_event:${customEvent.id}`,
  };
}

/**
 * Builds cohort definitions from a list of cohorts
 */
export function getCohortsDefinitions(cohorts) {
  return sortBy(
    (cohorts || []).map((cohort) => ({
      label: cohort.name,
      value: cohort.id,
      name: cohort.name,
      count: cohort.count,
      description: cohort.description,
      createdBy: cohort.created_by,
      lastEdited: cohort.last_edited,
      hidden: !cohort.is_visible,
      locked: cohort.is_locked,
    })),
    `label`,
  );
}

export const orderByLabel = lexicalCompose(
  boolComparator((item) => item.name === SPECIAL_EVENTS.TOP_EVENTS), // Top Events first
  baseComparator({transform: (item) => item.label && item.label.toLowerCase()}),
);

export function getCohortFromPropertyItem(item: PropertyItem): CohortSegment {
  let cohort = Number.isInteger(item.value) ? {id: item.value} : item.value.cohort;
  const isInlineCohort = cohort && !!cohort.raw_cohort;

  if (isInlineCohort) {
    cohort = {raw_cohort: {name: cohort.name || item.label, ...cohort.raw_cohort}};
  } else {
    cohort = {...(item.dataGroupId ? {data_group_id: item.dataGroupId} : {}), ...cohort};
  }

  return {cohort: {...cohort, name: item.label, negated: false}};
}
